module.exports = __webpack_public_path__ + "static/media/influencer-head-icon.79455dd2.svg";